var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_999)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 0 24)",
    fill: "#5f5d5e",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7476 11.9991L8.24978 16.5347C7.91688 16.8709 7.91688 17.413 8.24978 17.7491C8.40841 17.9097 8.62478 18 8.85045 18C9.07612 18 9.29249 17.9097 9.45111 17.7491L14.5496 12.6072C14.8835 12.2714 14.8835 11.7286 14.5496 11.3928L9.45133 6.25089C9.29249 6.09032 9.07612 6 8.85045 6C8.62478 6 8.40841 6.09032 8.24957 6.25089C7.91688 6.58707 7.91688 7.1292 8.25 7.46527L12.7476 11.9991Z",
    fill: "#4285F4"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7476 11.9991L8.24978 16.5347C7.91688 16.8709 7.91688 17.413 8.24978 17.7491C8.40841 17.9097 8.62478 18 8.85045 18C9.07612 18 9.29249 17.9097 9.45111 17.7491L14.5496 12.6072C14.8835 12.2714 14.8835 11.7286 14.5496 11.3928L9.45133 6.25089C9.29249 6.09032 9.07612 6 8.85045 6C8.62478 6 8.40841 6.09032 8.24957 6.25089C7.91688 6.58707 7.91688 7.1292 8.25 7.46527L12.7476 11.9991Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_999",
    x: -180,
    y: -180,
    width: 384,
    height: 384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 90
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_999",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRightArrow);
export default __webpack_public_path__ + "static/media/circle-right-arrow.b236882a2f05ea0cc9f5c8e8f885215e.svg";
export { ForwardRef as ReactComponent };